import React, { useState } from 'react'
import { Image, View } from 'react-native'
import Button from '../Button/Button'
import Credits from '../Credits/Credits'

import animatedGif from './animated_gif.gif'
import Dialog from '../Dialog/Dialog'
import { commonStyle } from '../../assets/TextStyles/TextStyles'

import PropTypes from 'prop-types'

const coverImage = require('./coverscreen_bg.png')

const CoverScreen = ({ onStartGame }) => {
  const [showInfo, setShowInfo] = useState(false)

  return (
    <View style={[styles.coverScreen, commonStyle.corner, commonStyle.dropShadow]}>
        <Image source={coverImage} style={styles.coverScreen} />
        <Image source={animatedGif} style={styles.gifanim} />
        <Button onPress={onStartGame} style={styles.startBtn} Title={'Aloita peli'} />
        <Button onPress={() => setShowInfo(true)} style={styles.infoBtn} Title={'Tiedot'} />
        <Dialog show={showInfo} content={<Credits/>} footer={[{ title: 'Sulje', callback: () => setShowInfo(false) }]} />
    </View>
  )
}

CoverScreen.propTypes = {
  onStartGame: PropTypes.func.isRequired
}

export default CoverScreen

const styles = {
  coverScreen: {
    position: 'absolute',
    width: 1200,
    height: 675
  },
  gifanim: {
    position: 'absolute',
    left: 470,
    top: 80,
    width: 258,
    height: 175
  },
  startBtn: {
    position: 'absolute',
    left: 220,
    top: 520
  },
  infoBtn: {
    position: 'absolute',
    right: 220,
    top: 520
  }
}
